<div class="p-grid">
	<div class="p-col-12 p-md-4">
		<div class="card h-100 p-0">
			<div class="d-flex flex-column">
				<div class="d-flex">
					<div class="h3 mx-4 mt-2 mb-1">{{ selectedReportItem?.name || "Add new report" }}</div>
				</div>
				<p-divider></p-divider>
				<div class="d-flex flex-column mx-2">
					<div class="mt-4">
						<span class="p-float-label">
							<p-dropdown
								#categorySelect
								[options]="reportCategories"
								optionLabel="label"
								optionValue="value"
								name="categorySelect"
								[(ngModel)]="selectedReportItem.category"
								[style]="{ width: '100%' }"
								appendTo="body"
								[autoDisplayFirst]="false"
								[virtualScroll]="true"
								virtualScrollItemSize="30"
								filter="true"
								(filterBy)="app.keys(reportCategories)"
								(onChange)="selectCategory($event)"
							></p-dropdown>
							<label for="categorySelect">Category</label>
						</span>
					</div>
					<span class="p-float-label mt-4" *ngIf="newCategoryOptionSelected">
						<input
							pInputText
							#reportCategoryNewInput
							name="reportCategoryNewInput"
							type="text"
							[(ngModel)]="selectedReportItem.category"
							class="w-100"
						/>
						<label for="reportCategoryNewInput">New category name</label>
					</span>
					<span class="p-float-label mt-4">
						<input pInputText #reportNameInput name="reportNameInput" type="text" [(ngModel)]="selectedReportItem.name" class="w-100" />
						<label for="reportNameInput">Name</label>
					</span>
					<span class="p-float-label mt-4">
						<textarea
							pInputTextarea
							#reportDescriptionInput
							name="reportDescriptionInput"
							[(ngModel)]="selectedReportItem.description"
							class="w-100 mt-1"
						></textarea>
						<label for="reportDescriptionInput">Description</label>
					</span>
					<div class="mt-4">
						<span class="p-float-label">
							<p-dropdown
								#reportAccessLevel
								[options]="reportAccessRoles"
								optionLabel="label"
								optionValue="value"
								name="reportAccessLevel"
								[(ngModel)]="selectedReportItem.accessLevel"
								[style]="{ width: '100%' }"
								appendTo="body"
								[autoDisplayFirst]="false"
								[virtualScroll]="true"
								virtualScrollItemSize="30"
								filter="true"
								(filterBy)="app.keys(reportAccessRoles)"
							></p-dropdown>
							<label for="reportAccessLevel">Access Level</label>
						</span>
					</div>

					<div class="mt-4">
						<span class="p-float-label">
							<p-multiSelect
								#reportOptionsSelect
								[options]="reportOptions"
								optionLabel="label"
								optionValue="value"
								name="reportOptionsSelect"
								[(ngModel)]="selectedReportItem.options"
								[style]="{ width: '100%' }"
								appendTo="body"
								[virtualScroll]="true"
								virtualScrollItemSize="30"
								filter="true"
								(filterBy)="app.keys(reportOptions)"
							></p-multiSelect>
							<label for="reportOptionsSelect">Report Options</label>
						</span>
					</div>

					<p-checkbox
						name="reportOptionsDisabled"
						binary="true"
						[(ngModel)]="selectedReportItem.optionDisabled"
						label="Disable Report"
						class="m-4"
					></p-checkbox>

					<div class="d-flex">
						<app-record-control-footer
							[hideCancel]=""
							[hideDelete]=""
							[hideSave]=""
							(onCancelChange)="selectedReportItem = undefined"
							(onDeleteChange)="onDelete()"
							(onSaveChange)="onSave()"
							[cancelDisabled]=""
							[deleteDisabled]="!selectedReportItem.key"
							[saveDisabled]="!selectedReportItem.name"
						></app-record-control-footer>
					</div>
					<div class="d-flex">
						<div class="d-flex w-100">
							<span class="p-float-label mt-4 flex-fill">
								<input
									pInputText
									#menuSectionKey
									name="selectedReportItemKey"
									type="text"
									[(ngModel)]="selectedReportItem.key"
									class="w-100"
									[disabled]="true"
								/>
								<label for="selectedReportItemKey">Report Key</label>
							</span>
							<fa-icon [icon]="['far', 'copy']" (click)="app.copyMessage(selectedReportItem.key)" class="ms-2 my-auto" size="lg"></fa-icon>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="p-col-12 p-md-4">
		<div class="card h-100">
			<p-tree *ngIf="reportItems" [value]="reportItems" selectionMode="single" (onNodeSelect)="onNodeSelect($event)"></p-tree>
		</div>
	</div>
</div>
